var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseModal',{ref:"modal",attrs:{"fixed-position":true},on:{"closed":_vm.onClosed,"ready":_vm.onReady}},[_c('PageSelector',{ref:"pageSelector",staticClass:"switcher",on:{"item-selected":_vm.itemSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }